import { Computer,PhoneAndroid,SportsEsports,TwoWheeler,Headset,Watch,Cake, } from "@mui/icons-material";
// import {Jacket}
const Shop_Data = [
    // recommended-id-1
    {
      id: 1,
      title: 'Recommended',
      Path: 'recommended',
      TitleIcon: Computer,
      items: [
        {
          id: 1,
          name: 'sony A7s ',
          brand:'sony',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://static.bhphoto.com/images/images500x500/sony_ilce7s_b_alpha_a7s_mirrorless_digital_1505306319_1044728.jpg',
          quantity:1,
          price: 290,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 2,
          name: 'apple iphone 12 (white)',
          brand:'apple',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-12-white-select-2020?wid=470&hei=556&fmt=png-alpha&.v=1604343705000',
          quantity:1,
          price: 999,
          oldPrice:1100,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 3,
          name: 'Apple Mackbook pro 13,3',
          brand:'appl',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://imgr.search.brave.com/8jqgrH4ECB8sOXJ6wREJuecsjeO-NDNzp7JQ-Pdy8cg/fit/474/225/ce/1/aHR0cHM6Ly90c2Uz/Lm1tLmJpbmcubmV0/L3RoP2lkPU9JUC5N/RHF4VWNiR0Q3bXcx/RXhkbXN2Yld3SGFI/YSZwaWQ9QXBp',
          quantity:1,
          price: 12000,
          oldPrice:15000,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 4,
          name: 'Tecno Pop 3',
          brand:'Tecno',
          rate:'4.5',
          reviews:'2  reviews',
          imageUrl: 'https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/T/M/_1631804522.jpg',
          quantity:1,
          price: 25,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 5,
          name: 'HP all in one',
          brand:'HP',
          rate:'3.5',
          reviews:'310 reviews',
          imageUrl: 'https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/E/E/_1624442027.jpg',
          quantity:1,
          price: 2300,
          oldPrice:5500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 6,
          name: 'Apple Watch Series 6',
          brand:'apple ',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/C/A/2054_1603120265.jpg',
          quantity:1,
          price: 2050,
          oldPrice:3500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 7,
          name: 'apple airpods max ',
          brand:'apple',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/G/I/63606_1609624223.jpg',
          quantity:1,
          price: 18,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 8,
          name: 'QASA 1.8L Blender',
          brand:'QASA',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/B/l/Blender-Grinder---QBL-18L40-7716963_9.jpg' ,
          quantity:1,
          price: 900,
          oldPrice:1200,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 9,
          name: 'Couple Necklace',
          brand:'necklace',
          rate:'4.9',
          reviews:'2 310 reviews',
          imageUrl: 'https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/K/B/86715_1617278762.jpg',
          quantity:1,
          price: 16,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        }
      ]
    },
    // watch-id-2
    {
      id: 2,
      title: 'Watch',
      Path: 'watch',
      TitleIcon:Watch,
      items: [
        {
          id: 11,
          name: 'FOSSL ',
          brand:'fossl',
          rate:'4.1',
          reviews:'1 310 reviews',
          imageUrl: 'https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/J/B/153021_1557966211.jpg',
          quantity:1,
          price: 290,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 12,
          name: 'RoadSter',
          brand:'RoadSter',
          rate:'4.8',
          reviews:'310 reviews',
          imageUrl: 'https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/Y/N/57312_1617967953.jpg',
          quantity:1,
          price: 999,
          oldPrice:1100,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 13,
          name: 'FOSSL Max ',
          brand:'fossl',
          rate:'4.1',
          reviews:'1 310 reviews',
          imageUrl: 'https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/D/G/148832_1590145890.jpg',
          quantity:1,
          price: 12000,
          oldPrice:15000,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 14,
          name: 'Geneva LED',
          brand:'geneva',
          rate:'4.5',
          reviews:'2  reviews',
          imageUrl: 'https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/E/K/77879_1631747620.jpg',
          quantity:1,
          price: 25,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 15,
          name: 'binbond top luxery',
          brand:'binbond',
          rate:'3.5',
          reviews:'310 reviews',
          imageUrl: 'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/69/208467/1.jpg?5524',
          quantity:1,
          price: 2300,
          oldPrice:5500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 16,
          name: 'Geneva LED',
          brand:'geneva',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/C/A/2054_1603120265.jpg',
          quantity:1,
          price: 2050,
          oldPrice:3500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 17,
          name: 'FOSSL ',
          brand:'fossl',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/49/191464/2.jpg?3176',
          quantity:1,
          price: 18,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 18,
          name: 'QASA  Blender',
          brand:'QASA',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/14/761224/1.jpg?0875' ,
          quantity:1,
          price: 900,
          oldPrice:1200,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 19,
          name: 'Elegant fashion',
          brand:'Rolle',
          rate:'4.9',
          reviews:'2 310 reviews',
          imageUrl: 'https://ng.jumia.is/unsafe/fit-in/300x300/filters:fill(white)/product/20/219693/1.jpg?7223',
          quantity:1,
          price: 16,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        }
      ]
    },
    // hats-id-3
    {
      id: 3,
      title: 'Hats',
      Path: 'hats',
      TitleIcon:Cake,
      items: [
        {
          id: 21,
          name: 'Brown Brim',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/ZYW3VTp/brown-brim.png',
          quantity:1,
          price: 25,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 22,
          name: 'Blue Beanie',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/ypkgK0X/blue-beanie.png',
          quantity:1,
          price: 18,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 23,
          name: 'Brown Cowboy',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/QdJwgmp/brown-cowboy.png',
          quantity:1,
          price: 35,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 24,
          name: 'Grey Brim',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/RjBLWxB/grey-brim.png',
          quantity:1,
          price: 25,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 25,
          name: 'Green Beanie',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/YTjW3vF/green-beanie.png',
          quantity:1,
          price: 18,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 26,
          name: 'Palm Tree Cap',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/rKBDvJX/palm-tree-cap.png',
          quantity:1,
          price: 14,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 27,
          name: 'Red Beanie',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/bLB646Z/red-beanie.png',
          quantity:1,
          price: 18,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 28,
          name: 'Wolf Cap',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/1f2nWMM/wolf-cap.png',
          quantity:1,
          price: 14,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 29,
          name: 'Blue Snapback',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/X2VJP2W/blue-snapback.png',
          quantity:1,
          price: 16,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        }
      ]
    },
    // -- Sneakers-id-4
    {
      id: 4,
      title: 'Sneakers',
      Path: 'sneakers',
      TitleIcon:SportsEsports,
      items: [
        {
          id: 30,
          name: 'Adidas NMD',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/0s3pdnc/adidas-nmd.png',
          quantity:1,
          price: 220,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 31,
          name: 'Adidas Yeezy',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/dJbG1cT/yeezy.png',
          quantity:1,
          price: 280,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 32,
          name: 'Black Converse',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/bPmVXyP/black-converse.png',
          quantity:1,
          price: 110,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 33,
          name: 'Nike White AirForce',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/1RcFPk0/white-nike-high-tops.png',
          quantity:1,
          price: 160,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 34,
          name: 'Nike Red High Tops',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/QcvzydB/nikes-red.png',
          quantity:1,
          price: 160,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 35,
          name: 'Nike Brown High Tops',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/fMTV342/nike-brown.png',
          quantity:1,
          price: 160,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 36,
          name: 'Air Jordan Limited',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/w4k6Ws9/nike-funky.png',
          quantity:1,
          price: 190,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 37,
          name: 'Timberlands',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/Mhh6wBg/timberlands.png',
          quantity:1,
          price: 200,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        }
      ]
    },
    // --Jackets-id-5
    {
      id: 5,
      title: 'Jackets',
      Path: 'jackets',
      TitleIcon:TwoWheeler,
      items: [
        {
          id: 58,
          name: 'Black Jean Shearling',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/XzcwL5s/black-shearling.png',
          quantity:1,
          price: 125,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 59,
          name: 'Blue Jean Jacket',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/mJS6vz0/blue-jean-jacket.png',
          quantity:1,
          price: 90,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 50,
          name: 'Grey Jean Jacket',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/N71k1ML/grey-jean-jacket.png',
          quantity:1,
          price: 90,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 51,
          name: 'Brown Shearling',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/s96FpdP/brown-shearling.png',
          quantity:1,
          price: 165,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 52,
          name: 'Tan Trench',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/M6hHc3F/brown-trench.png',
          quantity:1,
          price: 185,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        }
      ]
    },
    // women's-id-6
    {
      id: 6,
      title: 'Womens',
      Path: 'womens',
      TitleIcon:PhoneAndroid,
      items: [
        {
          id: 63,
          name: 'Blue Tanktop',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/7CQVJNm/blue-tank.png',
          quantity:1,
          price: 25,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 64,
          name: 'Floral Blouse',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/4W2DGKm/floral-blouse.png',
          quantity:1,
          price: 20,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 65,
          name: 'Floral Dress',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/KV18Ysr/floral-skirt.png',
          quantity:1,
          price: 80,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 66,
          name: 'Red Dots Dress',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/N3BN1bh/red-polka-dot-dress.png',
          quantity:1,
          price: 80,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 67,
          name: 'Striped Sweater',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/KmSkMbH/striped-sweater.png',
          quantity:1,
          price: 45,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 68,
          name: 'Yellow Track Suit',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/v1cvwNf/yellow-track-suit.png',
          quantity:1,
          price: 135,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 69,
          name: 'White Blouse',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/qBcrsJg/white-vest.png',
          quantity:1,
          price: 20,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        }
      ]
    },
    // mens-id-7
    {
      id: 7,
      title: 'Mens',
      Path: 'mens',
      TitleIcon:Headset,
      items: [
        {
          id: 70,
          name: 'Camo Down Vest',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/xJS0T3Y/camo-vest.png',
          quantity:1,
          price: 325,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 71,
          name: 'Floral T-shirt',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/qMQ75QZ/floral-shirt.png',
          quantity:1,
          price: 20,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 72,
          name: 'Black & White Longsleeve',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/55z32tw/long-sleeve.png',
          quantity:1,
          price: 25,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 73,
          name: 'Pink T-shirt',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/RvwnBL8/pink-shirt.png',
          quantity:1,
          price: 25,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 74,
          name: 'Jean Long Sleeve',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/VpW4x5t/roll-up-jean-shirt.png',
          quantity:1,
          price: 40,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        },
        {
          id: 75,
          name: 'Burgundy T-shirt',
          brand:'adidas',
          rate:'4.5',
          reviews:'2 310 reviews',
          imageUrl: 'https://i.ibb.co/mh3VM1f/polka-dot-shirt.png',
          quantity:1,
          price: 25,
          oldPrice:1500,
          detail:'lorem jknasn jdsfh sd iueiqe :keoiqw eqpweoi acal; ;aksiwe .nnb uewyr  sd fjdsfh uwery aloie   sndbksdfhi weihsdfia weiuewury  kksfsdjfh weuywe  ',
        }
      ]
    }
  ]  

export default Shop_Data;